<img *ngIf="theme === 'dark'"  src="/assets/logo/logo.svg" alt="logo" [height]="height" [width]="width">
<img *ngIf="theme === 'light'" src="/assets/logo/logo-light.svg" alt="logo" [height]="height" [width]="width">
